import '../../css/App.css'
import { useContext, useEffect } from 'react'
import { AppContext } from "../context/AppContext";
import { IAddUpdateLocationForm, IConfiguration, IFormFieldsValid } from '../../interfaces/interface';
import FormInternalDivFileTemplate from '../formTemplate/FormInternalDivFileTemplate';
import { AddUpdateLocationContext } from '../context/AddUpdateLocationContext';
import FormSelectInternalDivTemplate from '../formTemplate/FormSelectInternalDivTemplate';

function AddUpdateLocationForm() {
  
    const { navBarStatus, disMessage, config } = useContext(AppContext);
    const { Form, formVal, FileData, isJson} = useContext(AddUpdateLocationContext); 
    const [configuration] :IConfiguration[] = config
    const [isNavbarOpen] = navBarStatus;
    const [displayMessage]: string[] = disMessage;
    const [,setDisplayMessage]: React.Dispatch<React.SetStateAction<string>>[] = disMessage;
    const [formInput]: IAddUpdateLocationForm[] = Form;
    const [, setFormInput]: React.Dispatch<React.SetStateAction<IAddUpdateLocationForm>>[] = Form;
    const [file]: File[] | undefined[] = FileData;
    const [, setFile]: React.Dispatch<React.SetStateAction<File | undefined>>[] = FileData;
    const [formFieldsValid]:IFormFieldsValid[] = formVal;
    const [, setFormFieldsValid]: React.Dispatch<React.SetStateAction<IFormFieldsValid>>[] = formVal;
    const [isFileJson, setIsFileJson] =isJson

    const isDisabled = (): boolean => {
        if(displayMessage !== "none" || isNavbarOpen === true) return true
        return false
    }
    const submitHandler = (e: React.FormEvent<HTMLFormElement>) => {
        console.log(formInput);
        
        e.preventDefault(); 
        if(formValidation()){
            setDisplayMessage("add-update-location");
        }
    }
    const formValidation = ():boolean => {
        let isValid = true
        let tempFormFieldsValid = formFieldsValid
        // if(formInput.fileNamesList.length === 0 && isFileJson){
        //     tempFormFieldsValid = {
        //         isValid: false,
        //         displayMessage: true,
        //         message: "Missing name under properties in geoJson file"
        //     }
        // }
        if(file === undefined){
            tempFormFieldsValid = {
                isValid: false,
                displayMessage: true,
                message: "No file selected"
            }
            isValid = false;
        }
        if(!formFieldsValid.isValid){
            isValid = false;
        }
        setFormFieldsValid({...tempFormFieldsValid})
        return isValid;
}   
    const findNamesList = (fileData:string):void => {
        try{
            const obj = JSON.parse(fileData)
            let tempFileNamesList = formInput.fileNamesList
            if(obj.features && Array.isArray(obj.features)){
                let featuresArr:{properties: {name?:string}}[] = obj.features
                featuresArr.forEach((location) => {                
                    if(location.properties.name){
                        tempFileNamesList.push(location.properties.name)
                    }
                })            
            }
            if(tempFileNamesList.length === 0){
                setFormFieldsValid({
                    isValid: false,
                    displayMessage: true,
                    message: "Missing name under properties in geoJson file"
                })  
            }  
            setIsFileJson(true)      
            setFormInput({
                ...formInput,
                fileNamesList:tempFileNamesList,
                fileData: fileData
            })      
        }catch(e){
            setIsFileJson(false)      
            setFormInput({
                ...formInput,
                fileNamesList: [],
                fileData: fileData
            })            
        }        
    }
    const fileChangeHandler = (e:React.ChangeEvent<HTMLInputElement>):void =>  {
        let fileList = e.target.files        
        if(fileList && (fileList.length > 0)){            
                let file  = fileList[0]
                if (file.size <= 32000) {
                    setFile(file);
                    const reader = new FileReader();
                    reader.onload = function(e) {
                        let result = reader.result;
                        console.log(file);
                        if(typeof(result) === "string"){
                            findNamesList(result)
                            setFormFieldsValid({
                                isValid: true,
                                displayMessage: false,
                                message: ""
                            })
                        }
                    }
                    reader.readAsText(file);  
                }else{
                    clearFields()
                    setFormFieldsValid({ 
                        isValid: false,
                        displayMessage: true,
                        message: "File size is limited to 32K bytes"
                    })
                }
        }else{            
            clearFields()
            setFormFieldsValid({
                isValid: false,
                displayMessage: false,
                message: "No file selected"
            })
    } 
};
const selectChangeHandler = (e: React.ChangeEvent<HTMLSelectElement>):void => {
    setFormInput({
        ...formInput,
        locationType: e.target.value
    });
}
const fileClickHandler = (e: any):void => {
    e.target.value = ""
    clearFields()
    setFormFieldsValid({
        isValid: false,
        displayMessage: false,
        message: "No file selected"
    })
}
const clearFields = () => {
    setFormInput({
        ...formInput,
        fileData: "",
        fileNamesList: [],
      });
    setFile(undefined);  
}
    return (
        <form className="form-template" onSubmit={submitHandler}>
                <div className='form-template-top-container'>
                    <FormInternalDivFileTemplate 
                        id="file-upload"
                        label="Upload File *"
                        value={file? file.name: ""}
                        disabled={isDisabled()}
                        onChange={fileChangeHandler}
                        accept=".json, .geojson"
                        displayMessage={formFieldsValid.displayMessage}
                        message={formFieldsValid.message}
                        dataToolTip="Load one or more polygons from geo-json file"
                        onClick={fileClickHandler}
                    />
                    <FormSelectInternalDivTemplate 
                        id="assetType"
                        label="Location Type"
                        disabled={isDisabled()}
                        selectChangeHandler={selectChangeHandler}
                        optionList={configuration?.locationTypes}
                        errorSpace={true}
                        placeHolder="Please choose type..." 
                    />
                </div>  
                <div className='form-template-div-button'>
                    <button type="submit" className="submit-form-btn" disabled={isDisabled()}>
                        Upload
                    </button>
                </div>
            </form>
        );
}

export default AddUpdateLocationForm;
